var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighOffActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(7 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 13,
    x: 0.5,
    y: 0.5,
    fill: "#4092f5",
    stroke: "#4092f5",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 8h2v5h-2zM11 6h2v7h-2zM9 7h2v6H9zM5 3h2v10H5zM3 6h2v7H3zM1 9h2v4H1zM7 4h2v9H7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 4h2v9H7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighOffActive);
export default __webpack_public_path__ + "static/media/high-off-active.19da88f6d63ad7fcf45eafe057e0ecc0.svg";
export { ForwardRef as ReactComponent };